<template>
    <div class="movieDetailWrap">
        <!-- <nav-bar title=''></nav-bar> -->
        <div class="movieInfo">
            <img class="poster" :src="movieInfo.logo+'_300x300'" alt />
            <div class="basicInfo fc jsa">
                <div class="fr ac jsb">
                    <h2>{{movieInfo.name}}</h2>
                    <span v-if="movieInfo.rating > 0" class="rating">{{movieInfo.rating}}</span>
                </div>
                <p>
                    <span v-show="movieInfo.showmark" class="mark">{{movieInfo.showmark}}</span>
                </p>
                <span class="director ellipsis">导演：{{movieInfo.director}}</span>
                <div class="frr">
                    <button @click="goCinemaList" class="buyBtn">去购票</button>
                </div>
            </div>
            <!-- <img class="bg" :src="movieInfo.logo+'_300x300'" alt="">
            <div class="bg_shade"></div>-->
        </div>
        <div class="detailedInfo fc">
            <h3>{{movieInfo.name}} <span v-show="movieInfo.englishname">({{movieInfo.englishname}})</span></h3>
            <span>{{movieInfo.state}}/{{movieInfo.duration}}分钟/{{movieInfo.showmark}}</span>
            <span>{{movieInfo.playdate}} 上映</span>
            <span class="director">导演：{{movieInfo.director}}</span>
            <span class="actors">主演：{{movieInfo.actors}}</span>
            <p>内容简介：{{movieInfo.content}}</p>
        </div>

        <!-- <p class="movieDesc">{{movieInfo.content}}</p> 
        <button @click="goCinemaList" class="btn">选座购票</button>-->
    </div>
</template>

<script>
import navBar from "../../components/common/navBar.vue";
export default {
    data() {
        return {
            movieid: this.$route.query.movieid,
            citycode: this.$route.query.citycode,
            movieInfo: {}
        };
    },
    components: {
        navBar
    },
    beforeRouteEnter(to, from, next) {
        window.document.body.style.backgroundColor = "#FFF";
        next();
    },
    beforeRouteLeave(to, from, next) {
        window.document.body.style.backgroundColor = "#f2f2f2";
        next();
    },
    created() {
        this.getMovieInfo();
    },
    methods: {
        getMovieInfo() {
            this.$post({
                method: "movie.detailV4",
                movieid: this.movieid
            }).then(res => {
                if (res.success) {
                    this.movieInfo = res.data.movie;
                }
            });
        },
        goCinemaList() {
            this.$router.push({
                path: "/cinemaList",
                query: { movieid: this.movieid, citycode: this.citycode }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../../static/css/base";
.movieDetailWrap {
    padding-bottom: 120px;
    .movieInfo {
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        position: relative;
        font-size: 24px;
        overflow: hidden;
        border-bottom: 1px solid #e9e9e9;
        // .bg {
        //     position: absolute;
        //     top: 0;
        //     left: 0;
        //     width: 100%;
        //     height: 120%;
        //     overflow: hidden;
        //     transform: scale(1.2);
        //     z-index: -10;
        //     filter: blur(40px);
        // }
        // .bg_shade {
        //     position: absolute;
        //     top: 0;
        //     left: 0;
        //     width: 100%;
        //     height: 100%;
        //     background: rgba(0,0,0,0.15);
        //     z-index: -9;
        // }
        .poster {
            width: 166px;
            height: 200px;
            margin: 24px 24px 24px 0;
            z-index: 5;
            // border-radius: 12px;
        }
        .basicInfo {
            width: calc(100% - 190px);
            height: 200px;
            margin: 24px 0;
            float: right;
            z-index: 5;
            h2 {
                font-size: 30px;
            }
            .rating {
                font-size: 40px;
                color: $themeColor;
            }
            .mark {
                font-size: 24px;
                color: $themeColor;
                line-height: 36px;
                padding: 1px 4px;
                border: 1px solid $themeColor;
                display: inline-block;
                border-radius: 8px;
            }
            .director {
                font-size: 24px;
                color: #999;
            }
            .buyBtn {
                width: 150px;
                height: 60px;
                background: $themeColor;
                color: #fff;
                font-size: 30px;
                border-radius: 10px;
            }
        }
    }
    .detailedInfo {
        width: 100%;
        padding: 40px 30px;
        box-sizing: border-box;
        h3 {
            font-size: 30px;
            margin-bottom: 8px;
            line-height: 40px;
        }
        span, p {
            font-size: 24px;
            color: #999;
            line-height: 50px;
            max-height: 100%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/movie/movieDetail.vue